export default __webpack_public_path__ + "static/media/photo--lg--132.4d87acd8.jpg";